import { Moment } from 'moment-timezone';
import { z } from 'zod';

import { zodDate } from '../../utils/zodHelpers';
import { useAxleQuery } from '../apiHelpers';

export const numVisitsByWeek = z.array(
    z.object({
        start_date: zodDate(),
        end_date: zodDate(),
        num_visits: z.number(),
    }),
);

export type NumVisitsByWeek = z.infer<typeof numVisitsByWeek>;

export const useQhpUtilization = ({
    qhpId,
    startDatetime,
}: {
    qhpId: string;
    startDatetime: Moment;
}) =>
    useAxleQuery({
        path: `/metrics/qhp-utilization/${qhpId}`,
        params: {
            start_datetime: startDatetime.format(),
        },
        suspense: true,
        responseSchema: z.object({
            future_caseload: z.object({
                num_care_team_patients: z.number(),
                num_future_visits: z.number(),
            }),
            num_visits_by_week: numVisitsByWeek,
        }),
    }).data;
